import {
  Card,
  CardContent,
  Typography,
  Stack,
  IconButton,
  Avatar,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";

const AssessmentAdded = ({
  data,
  supplement,
  setDeleteConfirm,
  send,
  date,
}) => {
  const navigate = useNavigate();
  const handleSupplementDelete = async (data) => {
    setDeleteConfirm(true);
    let body = {
      type: data.type,
      supplement,
    };
    send(body);
  };

  console.log(data, "assessment data");

  const isDateLessThanCurrent = (dateString) => {
    if (!dateString) return false;

    const passedDate = new Date(dateString);
    const currentDate = new Date();

    return passedDate < currentDate;
  };
  return (
    <>
      {/* <div className="d-flex justify-content-between total_studyMaterial" >
        <div className="d-flex align-items-center gap-2" onClick={() => { navigate("/PublishedQList", { state: { assessmentId: data?.id } }) }}>
          <div>
            <img
              className="cm_icon"
              src="/ContentM_images/assessment_cm.svg"
              alt="preRead logo"
            ></img>
          </div>
          <span className="steram_preread">{data?.name}</span>
        </div>
        {!isDateLessThanCurrent(date) && <div className="deleteIcon" onClick={() => { handleSupplementDelete(data) }}>
          <img src="/ContentM_images/delete.svg" alt="menu dots logo"></img>
        </div>}
      </div> */}
      <Card
        variant="outlined"
        sx={{
          borderRadius: 2,
          mb: 2,
          boxShadow: 2,
          width: "80%",
          minHeight: 80,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <CardContent sx={{ py: 0.5, px: 2 }}>
          {/* Header */}
          <Typography
            variant="subtitle2"
            fontWeight={600}
            color="primary.main"
            gutterBottom
            sx={{ mb: 0.5 }}
          >
            Assessment
          </Typography>

          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            {/* Left Side */}
            <Stack
              direction="row"
              alignItems="center"
              spacing={1.2}
              onClick={() =>
                navigate("/PublishedQList", {
                  state: { assessmentId: data?.id },
                })
              }
              sx={{ cursor: "pointer" }}
            >
              <img
                className="cm_icon"
                src="/ContentM_images/assessment_cm.svg"
                alt="preRead logo"
              ></img>
              <Typography variant="body2" fontWeight={500}>
                {data?.name}
              </Typography>
            </Stack>

            {/* Right Side (Delete Button) */}
            {!isDateLessThanCurrent(date) && (
              <IconButton
                onClick={() => handleSupplementDelete(data)}
                color="error"
                size="medium"
              >
                <DeleteIcon />
              </IconButton>
            )}
          </Stack>
        </CardContent>
      </Card>
    </>
  );
};

export default AssessmentAdded;
